export default __webpack_public_path__ + "static/9-cf82002ad596009388ea8a3dd3861cb3.png";